import type { FhirResource, Reference } from 'fhir/r4';
import type { ResourceType } from '../types';

/**
 * With the `reference` property defined. This is always the case if it is derived from a resource
 * that has an ID
 */
export type CreateReference = Reference &
  Required<Pick<Reference, 'reference'>>;

type ID = string;

/**
 * Defined in the `meta.version` property of the FHIR ResourceType
 */
type VersionID = string;

type History = '_history';

export type VersionReferenceParts<T extends FhirResource> = [
  ResourceType<T>,
  ID,
  History,
  VersionID,
];

/**
 * This can only be used for internal references and is defined as per the FHIR specification
 * Docs: https://www.hl7.org/fhir/references.html#:~:text=References%20can%20be-,version,-specific%20%2D%20that%20is
 */
export type VersionReference<T extends FhirResource> = Reference & {
  reference: `${ResourceType<T>}/${ID}/${History}/${VersionID}`;
};
